import superFieldInfoList from '@/components/super-field-info-list/index.vue';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { ITreeNode } from '@root/utils/to-tree';
import viewModelDebugMixin from '@root/common/mixins/viewmodel-debug';
import { Getter } from 'vuex-class';
import dynamicComp from './dynamicComp.vue';
import tableCellEllipse from './comp/tableCellEllipse.vue';
import * as _ from 'lodash';
import cloneDeepWithDelete from '@/utils/clone-deep-with-delete';
import moment from 'moment';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { ReviewStatusMap } from '@/types/exception-management/dictionaries';
import Utils from '@/utils/common';
import businessMixin from './business-mixin.vue';
import compDefines from '@/common/resource/compRegCenter.json';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import detailDialog from '@/components/detail-dialog/index.vue';
import inputNumberWithAddon from '@/components/input-number-with-addon/index.vue';

import businessInputGroup from './businessInputGroup.jsx';
import mixinUtils from './utils.js';
import { post, download } from '@root/utils/httpWrap';

//获取组件注册中心根据extend依赖处理州生成的新list
function getExtendedCompRegCenterList() {
  return mixinUtils.generateNewListByListItemExtendDefine(compDefines.items, 'comp');
}

let compRegCenter = {
  ...compDefines,
  items: getExtendedCompRegCenterList()
};

function transformParam(p: any) {
  return {
    ...p,
    userId: ''
  };
}

const createSlotComp = (tpl, components?: any) => {
  return {
    components: components,
    props: {
      scope: Object,
      vm: Object
    },

    template: tpl
  };
};

let mixedUtils = {
    ...mixinUtils,
    ...Utils
  },
  compConstructors: Record<string, any> = {},
  u = mixedUtils;

Vue.prototype.moment = moment;
if (process.env.NODE_ENV != 'productioin') {
  Vue.prototype.log = window.console.log;
}

@Component({
  components: {
    ParkingLotSearch,
    tableCellEllipse,
    superFieldInfoList,
    exportArea: createSlotComp(`<span></span>`),
    dialogDefine: createSlotComp(`<span></span>`),
    dynamicComp,
    inputNumberWithAddon,
    businessInputGroup: businessInputGroup,
    detailDialog,
    singleTableFilterSelect: compConstructors.singleTableFilterSelectConstructor = Vue.extend({
      mounted() {
        let closestedVM = mixedUtils.closestVM(this, 'filterParam');

        if (this.dict != '') {
          if (Array.isArray(this.dict)) {
            this.dataList = this.dict;
          } else {
            this.dataList = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries[this.dict.trim()]);
          }
        } else {
          let dataMap = mixedUtils.getDataByModel(this, 'handler.dataMap') || this.getDataMapByHandler();

          this.dataList = typeof dataMap === 'object' ? Utils.toLabelVal(dataMap) : dataMap;
        }

        closestedVM.evtBus.$on('B_TABLE_FILTER_CLEAR', () => {
          this.val = '';
        });

        if (this.sortDescByLabel) {
          this.dataList = this.dataList.sort((a, b) => a.label.length - b.label.length);
        }

        closestedVM.unshiftWholeItem4Select(this.dataList);
      },
      props: {
        sortDescByLabel: {
          type: Boolean,
          default: false
        },
        removeItems: {
          type: Array,
          default: () => []
        },
        label: {
          type: String,
          default: ''
        },
        dict: {
          type: [String, Array],
          default: ''
        },
        httpKey: String,
        handleName: String,
        width: {
          default: 180,
          type: [String, Number]
        }
      },
      methods: {
        //带有hander:{model:xx,list:xx}结构的玩意儿是为了兼容最开始的一版
        getDataMapByHandler() {
          let handler = mixedUtils.closestVMProp(this, ...this.getClosestVMPropStrings());

          if (typeof handler === 'object' && 'dataMap' in handler) {
            return handler.dataMap;
          } else {
            return handler;
          }
        },
        getClosestVMPropStrings() {
          return [
            'handler',
            `filterParam.adapterDataForViewModel.${this.httpKey ? this.httpKey + 'Handler' : this.handleName}`,
            `filterParam.adapterDataForViewModel.${this.httpKey + 'Map'}`
          ];
        },
        handleChange(val) {
          this.val = val;
          //以前采用handleName处理值的变化，现在采用httpKey,所以此处做了兼容
          let handler = this.handler || mixedUtils.closestVMProp(this, ...this.getClosestVMPropStrings());
          if (handler && typeof handler.onChange === 'function') {
            handler.onChange(...arguments);
          } else {
            mixedUtils.closestVM(this, 'filterParam').evtBus.$emit('B_UPDATE_FILTER_PARAM', {
              key: this.httpKey,
              value: val
            });
          }
        }
      },
      data() {
        return {
          val: '',
          dataList: []
        };
      },
      computed: {
        computedDataList() {
          return this.dataList.filter(item => !(this.removeItems || []).find(row => row == item.label));
        }
      },
      template: `
      <TableFilterItem :label="label||labelInConstructor">
      <a-select :value="val" @change="handleChange" class="full-width">
        <a-select-option :key="item.label" v-for="item in computedDataList" :value="item.value">{{item.label}}</a-select-option>

      </a-select>
      </TableFilterItem>
      `
    }),
    reviewStatus: {
      props: {
        parentNode: Object
      },
      mounted() {
        let newObj = new compConstructors.singleTableFilterSelectConstructor({
          data() {
            return {
              labelInConstructor: '审核状态',
              handler: {
                dataMap: ReviewStatusMap,
                onChange: (str: String) => {
                  mixedUtils.closestVM(this, 'filterParam').filterParam.reviewStatus = str;
                }
              }
            };
          }
        });
        newObj.$parent = mixedUtils.closestVM(this, 'filterParam');
        newObj.$mount(this.$refs.mySpan);
      },
      data() {
        return {};
      },
      template: `<span ref="mySpan"></span>`
    }
  }
})
export default class listPage extends Mixins<Record<string, any>>(
  TableMixin,
  TableWidthMixin,
  viewModelDebugMixin,
  businessMixin
) {
  filterParam: Record<string, any> = {};
  filterParamCopy: Record<string, any> = {};
  defaultPageSize = 8;
  totalRecordNumFromHttpRes = 0;
  tableLoading: boolean = false;
  unitTransformFilterParams = [];

  addHMSPostFix4TimeKey = true;
  totalNumOfHttpRes: any;
  //数据字典等基础数据是否准备完毕
  isAppBasicDataReady = false;
  mixedUtils = mixedUtils;
  //是否有操作栏
  tableData: any[] = []; // 表数据
  totalRow: any = {}; // 合计
  isEdit: boolean = false;
  UI: Record<string, any> = {
    TableFilter: {
      items: []
    }
  };

  validateBeforeSearch: any = () => true;
  @Getter('user/resourcesTree')
  resources!: ITreeNode<any>[];
  @Watch('detailModel')
  detailModelChange(nv, ov) {
    if (ov != null && nv == null) {
      this.dynamicCompInstanceCollectionInDialog = {};
      this.evtBus.$emit('B_DETAIL_MODEL_CLEAR');
    }
  }

  //详情弹出层类型，某些探出框与之高度相似比如编辑，审核等，通过这个字段区分
  detailDialogType = 'DETAIL';
  dialogConfigKey = 'detailDialog';
  lodash = _;

  dynamicCompInstanceCollectionInDialog = {};

  defaultPrimaryUIConfig = {
    title: '一级标题',
    tableConfig: {
      tableHeader: {
        export: false
      },
      rowKey: 'id',
      //是否有操作栏
      operateColumn: true
    },
    detailDialog: {
      column: 1,
      title: '详情',
      width: 800,
      cancelText: '取消',
      okText: '确定'
    }
  };

  getPageTypeByJSONDesc() {
    if (this.customPrimaryUIConfig) {
      return this.customPrimaryUIConfig.PAGE_TYPE || null;
    } else {
      return null;
    }
  }

  compRegCenter = compRegCenter;

  getDict(key) {
    return this.$store.state.dictionaries.allDictionaries[key];
  }

  initialUIValue() {
    let newCustomPrimaryUIConfig = this.lodash.cloneDeep(this.customPrimaryUIConfig);
    if (this.getPageTypeByJSONDesc()) {
      'TableFilter'.split(' ').forEach(where => {
        newCustomPrimaryUIConfig[where].items.forEach((item, index) => {
          item.uuid = mixedUtils.guid();

          newCustomPrimaryUIConfig[where].items[index] = this.lodash.mergeWith(
            this.lodash.cloneDeep(compRegCenter.items.find(o => o.comp == item.comp)),
            item
          );
          //将所有时间组件初始值转换为moment对象
          if ('TableFilterItem.aRangePicker' == newCustomPrimaryUIConfig[where].items[index].comp) {
            newCustomPrimaryUIConfig[where].items[index].initialValue = newCustomPrimaryUIConfig[where].items[
              index
            ].initialValue.map(dataStr => moment(dataStr));
          }
        });
      });
    }

    return this.lodash.mergeWith({}, this.defaultPrimaryUIConfig, newCustomPrimaryUIConfig);
  }
  evtBus = new Vue();
  dataTransferCenter = {
    onTableData: (o: any) => o,
    onDetail: (o: any) => o,
    onSearch(o: any) {
      mixedUtils.log('on search invoked');
      return {
        parkIds: o.parkIds instanceof Array ? o.parkIds.join(',') : o.parkIds,
        currPage: this.current,
        pageSize: this.pageSize
      };
    }
  };
  detailModel = null;
  selectedRows = [];
  handleUIUpdated(key, value) {
    mixedUtils.log('update key and value--:', key, value);
  }
  get computedPagination() {
    return {
      ...this.pagination,
      pageSize: this.pagination.pageSize + 1,
      showTotal: (total: any) => `总共 ${this.totalRecordNumFromHttpRes} 条`
    };
  }

  onDetailDialogCancel() {
    this.detailModel = null;
    try {
      const { hideDialog } = this.$refs.detailDialog as any;
      hideDialog && hideDialog();
    } catch (e) {
      console.error(e);
    }
  }

  async onDetailDialogConfirm() {
    if (this.detailDialogType == 'DETAIL') {
      try {
        const { hideDialog } = this.$refs.detailDialog as any;
        hideDialog && hideDialog();
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let dialogConfig = mixedUtils.getDataByModel(
          this,
          'UI.' + this.getDialogConfigKeyByDialogType(this.detailDialogType)
        );

        let validateResult = true;
        try {
          const { superFieldInfoList } = (this.$refs.detailDialog as any).$refs as any;
          superFieldInfoList.form.validateFields(err => {
            if (err) {
              validateResult = false;
            }
          });
        } catch (e) {
          console.error(e);
        }

        if (!validateResult) {
          return false;
        }

        await this.createHttp(
          dialogConfig.behaviorConfig.onConfirm,
          Object.fromEntries(
            dialogConfig.behaviorConfig.onConfirm.httpKey.map(key => [key, this.detailModel.data[key]])
          )
        );

        this.operateSuccessWithReload();
      } catch (e) {
        console.warn('e---:', e);
        void 0;
      }
    }
  }
  async showDetailDialog(row: any, detailDialogType = 'DETAIL', isShowDialog = true) {
    try {
      this.onDetailDialogTypeChange(detailDialogType, this.detailDialogType);
    } catch (e) {
      void 0;
    }
    this.detailDialogType = detailDialogType;

    if (this.getPageTypeByJSONDesc()) {
      let dialogConfig = this.getDialogConfigByDialogLabel(detailDialogType),
        modelInOnlaunch = mixedUtils.getDataByModel(dialogConfig, 'behaviorConfig.onLaunch.model');
      if (modelInOnlaunch) {
        row = (await this.createHttp(null, modelInOnlaunch)).data;
      } else {
        row = (await this.createHttp('UI.detailDialog.behaviorConfig.onLaunch', row)).data;
      }
    }

    this.tableColumn2DetailFieldInfo(row, detailDialogType);
    this.$nextTick(() => {
      this.UI.detailDialog.cancelText =
        'dialogCancelText' in this ? this.dialogCancelText : this.UI.detailDialog.cancelText;
      try {
        const { showDialog } = this.$refs.detailDialog as any;
        isShowDialog && showDialog();
      } catch (e) {
        console.error(e);
      }
    });
  }

  addVM2Window(name, vm) {
    if (!this.isProd()) {
      window[name] = vm;
    }
  }
  //在提交时，纠正一下moment对象值等
  correntFormDataLikeMomentEtcDot(fd, deep = false) {
    if (!deep) {
      for (var i in fd) {
        if (fd[i] instanceof moment) {
          fd[i] = fd[i]._i || mixedUtils.formatDate(fd[i]._d);
        }
      }
    } else {
      alert('未实现');
    }
  }
  getSearchMap() {
    let copiedFilterParams = this.lodash.cloneDeep(this.filterParam);
    this.correntFormDataLikeMomentEtcDot(copiedFilterParams);
    let res = cloneDeepWithDelete.apply(
      null,
      [copiedFilterParams, ['adapterDataForViewModel']].concat(this.dataTransferCenter.onSearch.bind(this))
    );
    this.correntFormDataLikeMomentEtcDot(res);

    if (this.addHMSPostFix4TimeKey == true) {
      //处理时间
      for (var i in res) {
        if (/^\d{4}[-]\d{2}[-]\d{2}$/.test(res[i]) && !this.unitTransformFilterParams.includes(i)) {
          if (i.toLowerCase().includes('start')) {
            res[i] += ' 00:00:00';
          }
          if (i.toLowerCase().includes('end')) {
            res[i] += ' 23:59:59';
          }
        }
      }
    }

    return res;
  }

  getATagColor(text) {
    let color = 'cyan';
    if (!text) return color;
    if ('失败 未通过 到期 过期'.split(' ').find(item => text.includes(item))) {
      color = 'red';
    } else if ('成功 已 正常'.split(' ').find(item => text.includes(item))) {
      color = 'green';
    } else if ('未'.split(' ').find(item => text.includes(item))) {
      color = 'red';
    } else {
      color = 'cyan';
    }

    return color;
  }

  // 左右栏配置
  get flexColumns() {
    return [
      {
        id: 'table',
        hiddenHeader: true,
        padding: '20px 30px 30px'
      }
    ];
  }
  //处理分页表格分页变动
  handleTablePaginationChange() {
    if (!(this.tableData[this.tableData.length - 1] || {}).isTotalRow) {
      this.handleTableChange.apply(this, arguments);
      return false;
    }

    let arr = Array.from(arguments);
    let arg0 = _.cloneDeep(arr[0]);

    if (arr[0].pageSize % this.defaultPageSize != 0) {
      arg0.pageSize = this.pagination.pageSize;
    }

    arr[0] = arg0;

    const pager = { ...arr[0] };
    this.current = pager.current || 1;
    this.pageSize = pager.pageSize || 10;
    this.filters = arr[1];
    this.sorter = arr[2];
    this.fetchTableData();
  }
  current: any;
  pageSize: any;
  filters: any;
  sorter: any;
  //纠正分页栏每页条数
  correctPageSizeOfPaginationBar() {
    this.$nextTick(() => {
      try {
        var obj;
        //纠正国际化去掉显示英文问题：
        obj = mixedUtils.matchingDescendants(this, /-pagination$/).$el;
        obj.querySelector('.ant-select-selection-selected-value').innerHTML = this.pagination.pageSize;
        obj.querySelector('.ant-pagination-options-quick-jumper input').previousSibling.replaceWith('  跳转到');
        const dom = document.querySelector('.ant-table-pagination') as HTMLDivElement;
        dom.style.marginRight = '30px';
      } catch (e) {
        void 0;
      }
    });
  }

  getBasicInfoByDetailModel() {
    if ('基本信息' in this._self.detailModel) {
      return this._self.detailModel['基本信息'].data;
    } else {
      return this._self.detailModel[''].data;
    }
  }

  getDetailModelCompDefine(key) {
    if (!('' + key).includes('.')) {
      return this.detailModel.config[key.split('.')[0] - 0].fields;
    }
    return this.detailModel.config[key.split('.')[0] - 0].fields[key.split('.')[1] - 0];
  }
  //生成插槽映射，核心格式的可以为dataIndex,value为UIdefs
  get customSlots() {
    return {
      tableColumns: mixedUtils.list2ObjByProp(
        //
        this.UI.tableConfig.tableColumn.filter(item => item.comp),
        'httpKey'
      )
    };
  }

  //Label表示的是表格操作栏显示的文字
  getDialogConfigByDialogLabel(dialogLabel) {
    return (
      mixedUtils.getDataByModel(this, 'UI.' + this.getDialogConfigKeyByDialogType(dialogLabel)) ||
      mixedUtils.getDataByModel(this, 'UI.detailDialog')
    );
  }

  private generateDetailModelConfigByUIConfig(k, detailModel) {
    let config = mixedUtils.getDataByModel(this, k),
      extendDialog = config.fieldInfoListConfig.extendDialog,
      newConfig = {
        ...config,
        fieldInfoListConfig: []
      };

    let SuperFieldInfoConfig = extendDialog
      ? this.getDialogConfigByDialogLabel(extendDialog).fieldInfoListConfig
      : config.fieldInfoListConfig;

    SuperFieldInfoConfig.forEach(outerItem => {
      let newOuterItem = {
          ...outerItem,
          fields: []
        },
        groupName = outerItem.groupName;
      let removedGroup = mixedUtils.getDataByModel(config, 'fieldInfoListConfig.custom.removeGroup') || [];
      outerItem.fields.forEach(innerItem => {
        //首先遍历自定义节点从父类查找对应节点
        let findedItemInRewriteObj = extendDialog
          ? (mixedUtils.getDataByModel(config, 'fieldInfoListConfig.custom.items') || []).find(
              item => item.attrs.label == innerItem.attrs.label
            ) || {}
          : innerItem;

        //然后从组件注册中心查找对应节点
        let findedItemInCompRegCenter =
          compRegCenter.items.find(o => o.comp == (findedItemInRewriteObj.comp || innerItem.comp)) || {};

        innerItem = mixedUtils.deepExtend({}, findedItemInCompRegCenter, innerItem, findedItemInRewriteObj);
        innerItem.uuid = mixedUtils.guid();
        newOuterItem.fields.push(this.lodash.cloneDeep(innerItem));
      });

      !removedGroup.includes(groupName) && newConfig.fieldInfoListConfig.push(newOuterItem);
    });

    mixedUtils.log(newConfig, SuperFieldInfoConfig);
    let newGroup = this.lodash.cloneDeep(
      mixedUtils.getDataByModel(config, 'fieldInfoListConfig.custom.newGroup') || []
    );

    newGroup.forEach((newGroupOuter, newGroupIndex) => {
      newGroup[newGroupIndex].fields = newGroupOuter.fields.map(mapRow => {
        return u.deepExtend({}, compRegCenter.items.find(o => (u.log('ooooo-:', o), o.comp == mapRow.comp)), mapRow, {
          uuid: mixedUtils.guid()
        });
      });
    });

    newConfig.fieldInfoListConfig = newConfig.fieldInfoListConfig.concat(newGroup);
    return newConfig.fieldInfoListConfig;
  }

  private getDialogConfigKeyByDialogType(dialogType) {
    return (dialogType || this.detailDialogType) + '弹框配置';
  }
  private tableColumn2DetailFieldInfo(row: any, detailDialogType: String) {
    mixedUtils.log('detailDialogType---:', detailDialogType);
    let copiedRow = _.cloneDeep(row);

    if ('DETAIL' != detailDialogType && this.getPageTypeByJSONDesc()) {
      this.dialogConfigKey = this.getDialogConfigKeyByDialogType(detailDialogType);
      let dialogKeyInUI = 'UI.' + this.dialogConfigKey,
        fieldsConfig = this.generateDetailModelConfigByUIConfig(dialogKeyInUI, copiedRow);
      this.detailModel = {
        data: copiedRow,
        config: fieldsConfig
      };
      this.detailModel.flatFields = this.detailModel.config
        .map(item => item.fields)
        .reduce((arr, a) => arr.concat(a), []);
      return false;
    }

    //
    if ('DETAIL' == detailDialogType && this.UI.detailDialog.fieldInfoListConfig) {
      this.dialogConfigKey = 'detailDialog';
      this.detailModel = {
        data: copiedRow,
        //
        config: this.UI.detailDialog.fieldInfoListConfig
      };
      return false;
    }

    if (this.getPageTypeByJSONDesc()) {
      for (var i in copiedRow) {
        let rowItemInColumnConfig = this.tableColums.find(item => item.dataIndex == i);
        if (rowItemInColumnConfig && typeof rowItemInColumnConfig.customRender === 'function') {
          copiedRow[i] = rowItemInColumnConfig.customRender(copiedRow[i], copiedRow);
        }
      }
    }

    let basicInfo = {
      基本信息: {
        data: copiedRow,
        fields: this.tableColums
          .map((item: { dataIndex: any; title: any }) => ({ prop: item.dataIndex, label: item.title }))
          .filter((item: { label: string }) => !'序号 操作'.split(' ').includes(item.label))
      }
    };
    this.detailModel = this.dataTransferCenter.onDetail.call(this, basicInfo);
  }

  async exportTable(fileName: any) {
    let searchMap = this.getSearchMap();

    await this.requestHandler.export(searchMap, fileName);
  }
  unshiftWholeItem4Select(list) {
    list.unshift({
      value: '',
      label: '全部'
    });
  }

  printRecordOfTableRow() {
    console.log([...arguments]);
  }

  // 生成图片查看弹框所需要的数据渲染结构
  get reviewColums() {
    return [
      {
        imageSrc: 'image' in this.viewImageModelData ? 'image' : 'img',
        // test: console.log('test this--:', this),
        data: (this.viewImageDialogFieldsDefination || '')
          .split(' ')
          .map(item => ((arguments[0] = item.split('-')), { label: arguments[0][0], dataIndex: arguments[0][1] }))
      }
    ];
  }

  setVMData(modelStr, v) {
    return u.setDataByModel(this, modelStr, v);
  }
  getVMData(modelStr) {
    return u.getDataByModel(this, modelStr);
  }
  transformDictCnName2Int(modelStr, dict) {
    dict = this.getDict(dict);
    let v = u.getDataByLoopedData(this, modelStr),
      res = v;

    for (var i in dict) {
      if (dict[i] == v) {
        res = i;
      }
    }
    u.setLoopDataByArrayModel(this, modelStr, res);
  }

  getCompDefineByCompName(name, customDefine = null) {
    return this.mixedUtils.deepExtend({}, compRegCenter.items.find(item => item.comp == name), customDefine);
  }
  generateFunction(compDefine: any = {}) {
    let fStr =
        typeof compDefine.f === 'function'
          ? compDefine.f
          : (compRegCenter.dataTransfer.find(row => row.desc == compDefine.f) || { f: compDefine.f }).f,
      vm = this;

    let resNewFun = new Function('s', 'return !s?s:' + [].concat(fStr).join('+'));

    console.log('resNewFun--:', resNewFun.toString());
    return resNewFun;
  }

  //初始化table column config
  get initialTableColumnConfig() {
    if ('initialTableColumnData' in this) {
      return this.initialTableColumnData.call(this);
    }
    //
    let result = this.UI.tableConfig.tableColumn.map(item => {
      let o: Record<string, any> = {
        title: item.title,
        UIDefs: item,
        f: item.f || null,
        attrs: item.attrs || {},
        width: item.width
      };

      if (typeof item.httpKey === 'string') {
        o.dataIndex = item.httpKey;
        if (item.comp) {
          o.scopedSlots = {
            customRender: 'table-cell-render'
          };
        }
      } else if (Array.isArray(item.httpKey)) {
        o.customRender = (text: any, record: any, index: number) =>
          mixedUtils.getDataByMultiModel(record, ...item.httpKey);
      }

      return o;
    });

    let newResult = [],
      //
      allMergedSeqArr = this.UI.tableConfig.tableHeader.mergeHeader
        .concat({ seq: [] })
        .map(row => row.seq || row[0])
        .reduce((a, b) => a.concat(b));
    result.forEach((item, index) => {
      if (item.f != null) {
        item.customRender = this.generateFunction(item);
      }
      if (!allMergedSeqArr.includes(index)) {
        newResult.push(item);
      } else {
        //
        let mergeHandler = this.UI.tableConfig.tableHeader.mergeHeader.find(row => (row.seq || row[0]).includes(index)),
          mergedTitle = mergeHandler.title || mergeHandler[1],
          targetRow = newResult.find(row => row.title == mergedTitle);
        if (!targetRow) {
          targetRow = {
            title: mergedTitle,
            children: []
          };
          newResult.push(targetRow);
        }
        targetRow.children.push({
          ...item,
          key: item.dataIndex
        });
      }
    });
    return newResult;
  }

  updateAttrThroughTplEngine(attrs, data) {
    let newAttrs = this.lodash.cloneDeep(attrs);

    for (var i in newAttrs) {
      newAttrs[i] = mixedUtils.simpleTplEngine({
        tpl: newAttrs[i] || '',
        data: data || ''
      });
    }
    return newAttrs;
  }
  operateSuccessWithReload() {
    this.$message.success('操作成功');
    this.fetchTableData();
    try {
      const { hideDialog } = this.$refs.detailDialog as any;
      hideDialog && hideDialog();
      this.detailModel = null;
    } catch (e) {
      console.warn('operateSuccessWithReload e--:', e);
      void 0;
    }
  }

  // 表字段说明
  get tableColums() {
    return (
      []
        .concat(this.generateTableLeftIndexColumn())
        // .concat({ title: '序号', fixed: 'left', width: 70, customRender: this.renderIndexNumOfTheFirstColumn })
        .concat(this.initialTableColumnConfig)
        .concat(
          //
          this.UI.tableConfig.operateColumn
            ? {
                title: '操作',
                dataIndex: 'operation',
                fixed: 'right',
                width: 210,
                scopedSlots: { customRender: 'operation' }
              }
            : []
        )
    );
  }

  generateTableLeftIndexColumn() {
    return {
      title: '序号',
      fixed: 'left',
      width: 55,
      customRender: (text: any, record: any, index: number) => {
        if (record.isTotalRow) {
          return '合计';
        }
        return `${(this.current - 1) * this.pageSize + index + 1}`;
      }
    };
    // return { title: '序号', fixed: 'left', width: 70, customRender: this.renderIndexNumOfTheFirstColumn }
  }

  generateFilterParamFromJSONDesc() {
    if (!this.getPageTypeByJSONDesc()) {
      return false;
    }
    mixedUtils.log('generateFilterParamFromJSONDesc invoked');
    let res = Object.fromEntries(
      this.UI.TableFilter.items
        .map(item => item.attrs.httpKey.toString())
        .join(',')
        .split(',')
        .map(item => {
          let compDefine = this.UI.TableFilter.items.find(compD => [].concat(compD.attrs.httpKey).includes(item)),
            initValue = '';
          // mixedUtils.log('compDefine--:', compDefine)

          let getIndexByHttpKey = () => compDefine.attrs.httpKey.findIndex(findItem => findItem == item);

          //专门为车牌号组件做一个兼容，因为v-model决定是否清楚十分不合理
          if (compDefine.comp == 'TableFilterItem.PlateInput') {
            // mixedUtils.log('tempData4FilterParamGenerate--:', compDefine.tempData4FilterParamGenerate)

            if (Array.isArray(compDefine.attrs.httpKey)) {
              initValue = compDefine.tempData4FilterParamGenerate[getIndexByHttpKey()] || '';
              // this.vm.filterParam[httpKeys[1]] = compDefine.tempData4FilterParamGenerate[1] || ''
            } else {
              initValue = compDefine.tempData4FilterParamGenerate.join(',');
            }

            // initValue = ''
          } else {
            if ('initialValue' in compDefine) {
              if (typeof compDefine.initialValue === 'string') {
                initValue = compDefine.initialValue;
              } else if (Array.isArray(compDefine.initialValue) && Array.isArray(compDefine.attrs.httpKey)) {
                initValue = compDefine.initialValue[getIndexByHttpKey()] || '';
              } else {
                initValue = compDefine.initialValue;
              }
            }
          }

          return [item, initValue];
        })
    );
    u.log('generate filter param res--:', res);
    return res;
  }

  /**
   * 清空查询条件
   */
  onTableFilterClear(reFetchTableData = true) {
    for (var i in this.filterParamCopy) {
      if (i != 'adapterDataForViewModel') {
        this.filterParam[i] = _.cloneDeep(this.filterParamCopy[i]);
      } else {
        for (var j in this.filterParam.adapterDataForViewModel) {
          let v = this.filterParam.adapterDataForViewModel[j];
          if (this.filterParam.adapterDataForViewModel[j].hasOwnProperty('model')) {
            this.filterParam.adapterDataForViewModel[j].model = _.cloneDeep(
              this.filterParamCopy.adapterDataForViewModel[j].model
            );
          }
        }
      }
    }

    if (typeof this.onTableFilterClearCallback === 'function') {
      this.onTableFilterClearCallback(this.filterParam);
    }

    this.evtBus.$emit('B_TABLE_FILTER_CLEAR');
    reFetchTableData && this.fetchTableData(true);
  }

  mounted() {
    this.$nextTick(() => {
      this.filterParamCopy = _.cloneDeep(this.filterParam || {});
    });
  }

  // 处理选中的
  get rowSelection() {
    return {
      onChange: (selectedRowKeys: any, selectedRows: any) => {
        this.selectedRows = selectedRows;
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      onSelect: (record: any, selected: any, selectedRows: any) => {
        console.log(record, selected, selectedRows);
      },
      onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
        console.log(selected, selectedRows, changeRows);
      }
    };
  }

  warn(err, consoleType = 'warning') {
    console.warn(err, consoleType);
  }
  error(err) {
    this.warn(err, 'error');
  }

  updateFilterParam(extendFilterParam = true) {
    this.$nextTick(() => {
      this.filterParam = this.lodash.mergeWith(
        {},
        this.customFilterParam || {}, //兼容老的使用了这个属性的页面
        this.generateFilterParamFromJSONDesc()
      );
    });
  }

  getTargetByUUidAndWhere(uuid, where) {
    return mixedUtils.getDataByModel(this, where).find(item => item.uuid == uuid);
  }

  getDyncmicInstance(fun) {
    return Object.values(this.dynamicCompInstanceCollectionInDialog).find(fun);
  }

  initialEvtBus() {
    this.evtBus.$on('B_UPDATE_DETAIL_MODEL_CONFIG', v => {
      let newRow;
      this.detailModel.config = this.detailModel.config.map(
        item => ((newRow = v.find(group => group.groupName == item.groupName) || item), newRow)
      );
    });
    this.evtBus.$on('B_UPDATE_DATE_BY_DYNAMIC_COMP', o => {
      const { where } = o;
      if (where == 'UI.TableFilter.items') {
        this.updateFilterParam();
      } else if (/detailModel.config.\d.fields/.test(where)) {
        this.getTargetByUUidAndWhere(o.compDefine.uuid, o.where).initialValue = o.v;
        mixedUtils.setDataByModel(this.detailModel.data, o.compDefine.attrs.httpKey, this.lodash.cloneDeep(o.v));

        if ((o.compDefine.syncWith || '').trim() != '') {
          mixedUtils.setDataByModel(this.detailModel.data, o.compDefine.syncWith, this.lodash.cloneDeep(o.v));
          let dynamicCompInstance: any = this.getDyncmicInstance(
            item => item.compDefine.attrs.httpKey == o.compDefine.syncWith
          );
          if (dynamicCompInstance && 'model' in dynamicCompInstance) {
            dynamicCompInstance.model = this.lodash.cloneDeep(o.v);
          }
        }
      }
    });

    if (this.getPageTypeByJSONDesc()) {
      this.updateFilterParam();
    }

    this.evtBus.$on('B_UPDATE_FILTER_PARAM', o => {
      this.filterParam[o.key] = o.value;
    });
  }
  isDetailPage() {
    return this.getVMData('$route.query.' + this.UI.tableConfig.rowKey) != undefined;
  }
  created() {
    if (this.$route.fullPath !== '/smart-parking/stored-card-management/stored-card-create?null=undefined') {
      mixedUtils.poll(
        () => this.$store.state.dictionaries.allDictionaries.apply_type,
        () => {
          this.isAppBasicDataReady = true;

          this.$nextTick(() => {
            this.evtBus.$emit('B_APP_READY');
          });
        },
        () => {},
        20000,
        50
      );

      this.evtBus.$on('B_APP_READY', () => {
        this.$nextTick(() => {
          if (this.isDetailPage()) {
            this.handleOperateBtnClick(
              {
                action: '打开详情页面'
              },
              this.$route.query
            );
          } else {
            this.fetchTableData();
          }
        });
      });

      this.UI = this.initialUIValue();
      Vue.observable(this.UI);
      this.defaultPageSize = this.pageSize;

      this.initialEvtBus();
      this.$watch('$route.query.' + this.UI.tableConfig.rowKey, (nv, ov) => {
        if (!nv && ov) {
          this.detailModel = null;
          this.fetchTableData();
        }
      });
    }
  }

  createHttp(functionDesc: any, params) {
    let returnValue;

    let getUrl = () =>
        typeof functionDesc === 'string' || functionDesc == null
          ? mixedUtils.getDataByModel(this, functionDesc + '.httpUrl') || null
          : functionDesc.httpUrl,
      nope = () =>
        new Promise((resolve, reject) => {
          resolve({
            data: params
          });
        });
    mixedUtils.log('get url--:', getUrl(), functionDesc, params);
    let compatibleAdapter = {
      'UI.TableFilter': 'list',
      'UI.tableConfig.tableHeader.export': 'export'
    };
    if ('requestHandler' in this) {
      if ('export' in this.requestHandler && functionDesc == 'UI.tableConfig.tableHeader.export') {
        returnValue = this.requestHandler.export.call(this, this.getSearchMap(), this.UI.title);
      } else {
        returnValue =
          this.getPageTypeByJSONDesc() && !getUrl()
            ? nope()
            : (this.requestHandler[compatibleAdapter[functionDesc]] || nope).call(this, params);
      }
    } else {
      if (getUrl() == null) {
        returnValue = nope();
      } else if (functionDesc == 'UI.tableConfig.tableHeader.export') {
        returnValue = download(getUrl(), transformParam(params), this.UI.title);
      } else {
        returnValue = post(getUrl(), transformParam(params));
      }
    }

    returnValue.catch(error => {
      this.$message.error(this.getHttpErrorMsg(error));
    });

    return returnValue;
  }

  isProd() {
    return process.env.NODE_ENV == 'production';
  }

  async handleOperateBtnClick(item, record) {
    switch (item.action) {
      case '打开详情弹框': {
        this.showDetailDialog(record);
        break;
      }
      case '打开详情页面': {
        this.$router.push({
          path: '/smart-parking/stored-card-management/stored-card-create-detail',
          query: { detail: JSON.stringify(record) }
        });
        break;
      }
      case '仅使用弹框服务': {
        await this.showDetailDialog(record, item.label, false);
        break;
      }
      default: {
        this.showDetailDialog(record, item.label);
        break;
      }
    }
  }

  getHttpErrorMsg(error) {
    if (typeof error === 'string') {
      return error;
    } else {
      try {
        return error.msg || error.message || error.data.msg || error.data.message || '系统繁忙，请稍后再试';
      } catch (e) {
        return '系统繁忙，请稍后再试';
      }
    }
  }

  /**
   * 查询列表
   */
  async fetchTableData(resetCurrent?: boolean) {
    if (this.tableLoading) return false;
    this.tableLoading = true;
    try {
      if (this.validateBeforeSearch() === false) {
        return false;
      }

      let searchMap = this.getSearchMap();

      let rowKey = mixedUtils.getDataByModel(this, 'UI.tableConfig.rowKey');

      const { status, data } = await this.createHttp('UI.TableFilter', {
        ...searchMap,
        currPage: this.current,
        pageSize: this.pageSize
      });

      let { datas = [], totalNum = 0 } = data || {};

      let generatedData = [];

      this.tableData = [];
      this.totalRow = {};

      if (this.getPageTypeByJSONDesc()) {
        if (this.UI.tableConfig.totalColumn.length > 0) {
          let totalRow = {};
          this.UI.tableConfig.totalColumn
            .map(
              (index, totalRowIdx) =>
                (
                  this.UI.tableConfig.tableColumn.find((item, idx) =>
                    Number.isInteger(index) ? idx == index : item.httpKey == index
                  ) || { httpKey: null }
                ).httpKey
            )
            .filter(key => key != null)
            .forEach(key => {
              //total中的字段,首先读取同名的key，没有的话再读取字段映射,没有的话再以Total为后缀读取
              totalRow[key] =
                data.total[key] ||
                data.total[
                  mixedUtils.getDataByModel(this, 'UI.tableConfig.totalColumnFieldsMapping.' + key) || key + 'Total'
                ];
            });
          totalRow = {
            [rowKey || 'uuid']: 'i am total',
            isTotalRow: true,

            ...totalRow
          };
          // datas.length == 0 && this.$message.warning('暂无数据')
          this.totalRow = { ...totalRow };
          datas.length > 0 && (generatedData = datas);
        } else {
          generatedData = datas;
        }
      } else {
        if (typeof this.dataTransferCenter.onTableData === 'function') {
          generatedData = this.dataTransferCenter.onTableData.call(this, datas, data);
        } else {
          generatedData = datas;
        }
      }

      generatedData.forEach((item, index) => {
        item.leftIndex = index;
        item[rowKey || 'uuid'] = u.guid();
      });
      this.tableData = generatedData;

      this.totalNumOfHttpRes = Number(totalNum);

      this.totalRecordNumFromHttpRes = totalNum;

      if (this.tableData.length == 0) {
        this.total = 'total' in data ? 1 : 0;
      } else {
        this.total = Number(totalNum) + ('total' in data ? window.Math.ceil(totalNum / this.pagination.pageSize) : 0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (resetCurrent) {
        this.current = 1;
      }
      this.tableLoading = false;
    }
  }

  total: any;

  // 表头筛选
  onSortChange({ sortList = [] }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    this.current = 1;
    this.fetchTableData();
  }
}

export const createSlotCompFun = createSlotComp;
